import React, { FC } from "react";
import { Button, Popconfirm, Space, Spin, Typography } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { Permission } from "@ticketingplatform/api/dist/__generated__/globalTypes";
import useHasPermissions from "hooks/useHasPermissions";
import Header from "components/layout/Header";

import { UserForm } from "../UserForm";

import { useUserDetails } from "./hooks";

const UserDetails: FC = () => {
  const { user, loading, onDeleteUser } = useUserDetails();
  const intl = useIntl();
  const canDeleteUser = useHasPermissions([Permission.USER_DELETE]);

  if (loading) return <Spin />;

  const fullName = [user.input.firstName, user.input.lastName]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage
            defaultMessage="{name} details"
            values={{ name: fullName }}
          />
        </Typography.Title>
      </Header>
      <Space />
      <UserForm loading={loading} initialValues={user} isReadOnly />
      {canDeleteUser && (
        <Popconfirm
          title={intl.formatMessage({
            defaultMessage: "Are you sure you want to delete user?",
          })}
          onConfirm={onDeleteUser}
        >
          <Button type="primary" danger htmlType="button">
            <FormattedMessage defaultMessage="Delete User" />
          </Button>
        </Popconfirm>
      )}
    </>
  );
};

export default UserDetails;
